export default {
  REDUX_NAMESPACE: 'IULI/SALES',

  SET_FILTER: 'SALES/SET_FILTER',
  SET_FILTER_SALE_COMPETENCY_DATE: 'SALES/SET_FILTER_SALE_COMPETENCY_DATE',
  SET_FILTER_SALE_STATUSES: 'SALES/SET_FILTER_SALE_STATUSES',
  SET_FILTER_SALE_SOURCES: 'SALES/SET_FILTER_SALE_SOURCES',
  SET_FILTER_SALE_BANK_ACCOUNTS: 'SALES/SET_FILTER_SALE_BANK_ACCOUNTS',
  SET_FILTER_SALE_CATEGORIES: 'SALES/SET_FILTER_SALE_CATEGORIES',
  SET_FILTER_SALE_PRODUCTS: 'SALES/SET_FILTER_SALE_PRODUCTS',
  SET_FILTERS: 'SALES/SET_FILTERS',

  SET_FILTER_INVOICE_DATE: 'SALES/SET_FILTER_INVOICE_DATE',
  SET_FILTER_INVOICE_STATUS: 'SALES/SET_FILTER_INVOICE_STATUS',
  SET_FILTER_INVOICE_OPERATION: 'SALES/SET_FILTER_INVOICE_OPERATION',

  SET_SORT_MODEL: 'SALES/SET_SORT_MODEL',

  SET_PAGE_SIZE: 'SALES/SET_PAGE_SIZE',
  SET_CURRENT_PAGE: 'SALES/SET_CURRENT_PAGE',

  SET_INITIAL_STATE: 'SALES/SET_INITIAL_STATE',
};
